<div class="container">
  <header class="header">
    <app-page-close-button (click)="goBack()"></app-page-close-button>
    <div class="title">Agreement Configuration</div>
  </header>

  <div class="content">
    <app-vertical-tabs [tabs]="verticalTabs" (tabSelected)="handleTabSelected($event)"
                       [selectedTabId]="selectedVerticalTab"></app-vertical-tabs>
    <div class="card">
      @if (selectedVerticalTab === TAB_IDS.SETUP) {
        <div class="setup_tab_header">
          <div class="title">Setup Configuration</div>
          <div class="action_buttons" *ngIf="setupTabEdit">
            <button class="secondary_button" (click)="goBack()">Cancel</button>
            <button class="primary_button"
                    (click)="saveAgreementConfiguration()">{{ currentAction === AGREEMENT_CONFIGURATION_ACTIONS.ADD_NEW_AGREEMENT ? 'Save' : 'Update' }}
            </button>
          </div>
        </div>
        <div class="setup_tab_content">
          <!--Common Criteria-->
          <div class="common_criteria_container">
            <div class="title">Billing Rules</div>
            <div class="divider"></div>
            <div class="common_criteria" (click)="addRulesForCommonCriteria()">+ Add Rules</div>
            <div class="rules-container" *ngIf="commonCriteria.length > 0">
              <div class="rule-pill" *ngFor="let rule of commonCriteria" (click)="addRulesForCommonCriteria()">
                {{ getDisplayTextForDeterminant(rule.determinant) }} {{ getDisplayTextForOperator(rule.operator) }}
                {{ getValuesToPrint(rule) }} <span *ngIf="rule.values.length > 3">...</span>
              </div>
            </div>
          </div>
          <!--Charges Table-->
          <div class="charge_table_container">
            <div class="title">Agreement Charges</div>
            <div class="header">
              <form [formGroup]="agreementChargeForm" (ngSubmit)="addCharges()">
                <div class="form_item">
                  <app-autocomplete-dropdown
                    [formControlName]="'charge'"
                    [placeholder]="'Search Charge'"
                    [apiUrl]="'v1/charges/list'"
                    [additionalFilters]="[
                    {
                          'name': 'CHARGE_ID_NOT_IN',
                          'alias':'id_not_in',
                          'operator':'NOT_IN',
                          'value': selectedChargeIds.size > 0 ?  Array.from(selectedChargeIds) : ['']
                    }]"
                    [filterByKeys]='["NAME_CONTAINS"]'
                    limit="10"
                    [orderBy]='{ "name": "asc" }'
                    [filterByKey]="'name'"
                    [bindLabel]="'name'"
                    [returnRawValue]="true"
                    [bindValue]="'id'"
                    [displayColumns]='[
            { "key": "name", "header": "Name" },
            { "key": "code", "header": "Code" }
          ]'
                  ></app-autocomplete-dropdown>
                  <div class="add_button">
                    <button class="tertiary_button" type="submit" [ngClass]="{'disabled': !agreementChargeForm.valid}">
                      Add Charge
                    </button>
                  </div>
                </div>
              </form>
            </div>

            <app-editable-table [ngClass]="{section_disabled: !setupTabEdit}"
                                [tableHeaders]="chargesEditableTableConfig"
                                [tableData]="chargesEditableTableData"
                                [showInputFieldsOnTh]="false"
                                [deletionAllowed]="true"
                                (dataDeleted)="handleDataDeletion($event)"
            ></app-editable-table>
          </div>
          <div class="divider"></div>
          <!--Form -->
          <form [formGroup]="basicDetailsForm" class="basic_details_form">

            <div class="form-group" style="width: 281px">
              <label for="priority" class="required_field_label">Priority</label>
              <input
                id="priority"
                type="number"
                class="form-control"
                formControlName="priority"
                placeholder="Enter priority"
                [ngClass]="{ 'form_error': basicDetailsForm.get('priority')?.invalid && basicDetailsForm.get('priority')?.touched }"
              />
              <div class="form_validation_error_new"
                   [ngClass]="{'visible': basicDetailsForm.get('priority')?.invalid && basicDetailsForm.get('priority')?.touched}">
                <small *ngIf="basicDetailsForm.get('priority')?.errors?.['required']">Priority is required</small>
              </div>

            </div>


            <div class="form-group">
              <label for="description">Description</label>
              <textarea
                id="description"
                rows="3"
                class="form-control"
                placeholder="Enter description"
                formControlName="description"
                [ngClass]="{ 'form_error': basicDetailsForm.get('description')?.invalid && basicDetailsForm.get('description')?.touched }"
              ></textarea>
              <div class="form_validation_error_new"
                   [ngClass]="{'visible': basicDetailsForm.get('description')?.invalid && basicDetailsForm.get('description')?.touched}">
                <small *ngIf="basicDetailsForm.get('description')?.errors?.['required']">Description is required</small>
              </div>
            </div>


          </form>


        </div>
      } @else if (selectedVerticalTab === TAB_IDS.TARIFF_AND_REBATE) {
        @if (agreementConfigurationData?.agreementCharges?.charges?.length === 0) {
          <app-no-data [msg]="'No Charges Applied'"
                       style="height:100%;width: 100%;display: flex;align-items: center; justify-content: center"></app-no-data>
        } @else {
          <app-item-selector-panel
            #itemSelectorPanel
            [listReadOnly]="true"
            [showLeftPanelCheckBox]="false"
            [itemsTitle]="'Charges'"
            [entity]="'CUSTOMER_AGREEMENT_CHARGES'"
            [items]="agreementConfigurationData?.agreementCharges?.charges"
            (onItemSelection)="handleItemSelectorPanelSelection($event)"
          ></app-item-selector-panel>
        }
      }
    </div>

  </div>

</div>

<ng-template #tariffAndRebateTemplate class="tariff_rebate_template">
  <app-horizontal-tabs [tabs]="horizontalTabs"
                       [(selectedTab)]="selectedHorizontalTab"
                       style="width: 100%;"></app-horizontal-tabs>
  @if (selectedHorizontalTab === TAB_IDS.TARIFF) {
    <app-tariff style="width: 100%;"></app-tariff>
  } @else if (selectedHorizontalTab === TAB_IDS.REBATE) {
    <app-coming-soon></app-coming-soon>
  }

</ng-template>
